import { render, staticRenderFns } from "./SwitchOrdersDashboard.vue?vue&type=template&id=5160fa6e&scoped=true"
import script from "./SwitchOrdersDashboard.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersDashboard.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersDashboard.vue?vue&type=style&index=0&id=5160fa6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160fa6e",
  null
  
)

export default component.exports